import PropTypes from 'prop-types'

const noteTypes = {
  created_by: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  body: PropTypes.string.isRequired,
}
const verificationTypes = {
  contact: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  documents: PropTypes.array,
  note: PropTypes.shape(noteTypes),
  sentiment: PropTypes.string,
  verification_type_name: PropTypes.string,
}
const VerificationNoteProps = {
  verification: PropTypes.shape(verificationTypes).isRequired,
  showDocs: PropTypes.bool,
}

export { VerificationNoteProps }
